import * as yup from "yup"

export const max = {
  fullname: [50, "ניתן להזין עד 50 תווים"] as [number, string],
}

export const required = {
  default: "שדה זה הינו שדה חובה",
  firstName: "יש להזין שם פרטי",
  lastName: "יש להזין שם משפחה",
  phoneNumber: "יש להזין מספר טלפון",
  licenseNumber: "יש להזין לוחית רישוי",
  licenceOrChassis: "נא הכנס מספר רישוי או שילדה",
  modelId: "בחר דגם",
  area: "בחר איזור",
  skuOrName: "נא הכנס טקסט חופשי או מספר פריט",
}

export const regex = {
  numbersAndLetters: /^[a-zA-Zא-תא-ת0-9 ]+$/,
  numbers: /^[0-9]*$/,
  singleName: /^[a-zA-Zא-ת ״\-,.׳]+$/,
  fullName: /([a-zA-Zא-ת'"\\.-/,].+\s).+/,
  name: /^[A-Za-z\u00C0-\u017F\u0590-\u05fe ,.'-]+$/,
  phoneNumber: /^05\d([-]{0,1})\d{7}$/,
  licenseNumber:
    /^([0-9]{2}-[0-9]{3}-[0-9]{2}|[0-9]{3}-[0-9]{2}-[0-9]{3}|[0-9]{7,8})$/,
  licenceOrChassis:
    /^(([0-9]{2}-[0-9]{3}-[0-9]{2}|[0-9]{3}-[0-9]{2}-[0-9]{3}|[0-9]{7,8})|([A-Z]{2}[A-Z0-9]{12}))$/,
}

export const invalid = {
  numbers: "יש להזין ספרות בלבד",
  numbersShort: "ספרות בלבד",
  numbersAndLetters: "ספרות ואותיות",
  fullName: "שם מלא לא תקין",
  name: "יש להזין אותיות בעברית / אנגלית בלבד",
  email: "כתובת המייל אינה תקינה",
  phoneNumber: "מספר הטלפון אינו תקין",
  licenseNumber:
    "לוחית רישוי אינה תקינה, נא להזין מספר בעל 7-8 ספרות שמורכב מספרות בלבד",
  licenceOrChassis: "מספר רישוי או שילדה לא תקין",
}

export const schemaCommon = {
  phoneNumber: yup
    .string()
    .matches(regex.phoneNumber, "עד 10 ספרות, ללא מקף")
    .length(10, "עד 10 ספרות, ללא מקף")
    .required("עד 10 ספרות, ללא מקף")
    .max(10, "עד 10 ספרות, ללא מקף"),
  firstName: yup
    .string()
    .matches(regex.singleName, "רק אותיות בעברית או באנגלית בבקשה")
    .min(2, "יש להזין לפחות שתי אותיות תחת השם")
    .max(50, "יש להזין עד 50 תווים בלבד")
    .required(required.default),
  lastName: yup
    .string()
    .matches(regex.singleName, "רק אותיות בעברית או באנגלית בבקשה")
    .min(2, "יש להזין לפחות שתי אותיות תחת השם")
    .max(50, "יש להזין עד 50 תווים בלבד")
    .required(required.default),
  fullName: yup
    .string()
    .matches(regex.fullName, "שם מלא בבקשה :)")
    .max(100, "יש להזין עד 100 תווים בלבד")
    .required(required.default),
  email: yup.string().email("כתובת המייל לא תקינה").required(required.default),
  city: yup.string(),
  street: yup.string(),
  apartmentNumber: yup.string().matches(regex.numbers, invalid.numbersShort),
  floorNumber: yup.string().matches(regex.numbers, invalid.numbersShort),
  entranceNumber: yup
    .string()
    .matches(regex.numbersAndLetters, invalid.numbersAndLetters),
  comments: yup.string().max(200, "ניתן להזין עד 200 תווים"),
  termsOfUseCheckbox: yup
    .boolean()
    .required("")
    .oneOf([true], "יש לאשר את תנאי השימוש"),
  onlyNumbers: yup.string().matches(regex.numbers, invalid.numbersShort),
  organization: yup.string().max(100, "יש להזין עד 100 תווים בלבד"),
  organizationTitle: yup.string().max(100, "יש להזין עד 100 תווים בלבד"),
  checkboxRequired: yup.boolean().required("").oneOf([true], "שדה חובה"),
  checkboxNotRequired: yup.boolean().defined(),
  licenseNumber: yup
    .string()
    .required(
      "לוחית רישוי אינה תקינה, נא להזין מספר בעל 7-8 ספרות ברצף וללא מקף"
    )
    .matches(regex.licenseNumber, invalid.licenseNumber),
  chassis: yup.string().required("מספר שילדה אינו תקין"),
  catalog: yup.string().required(required.default),
}
